<template>
  <div class="ia-configuracoes-container">
    <!-- Header -->
    <header class="ia-header">
      <div class="ia-header-title">
        <h4>Configurações de IA</h4>
        <span>Consumo, Preços e Templates dos provedores de IA</span>
      </div>
    </header>

    <!-- Toggles grandes -->
    <div class="ia-toggles">
      <button
        class="ia-toggle-btn"
        :class="abaAtiva === 'consumo' ? 'active' : ''"
        @click="abaAtiva = 'consumo'; buscarDados(1)"
      >
        <i class="bi bi-graph-up-arrow"></i> Consumo
      </button>
      <button
        class="ia-toggle-btn"
        :class="abaAtiva === 'precos' ? 'active' : ''"
        @click="abaAtiva = 'precos'; buscarPrecos(1)"
      >
        <i class="bi bi-currency-dollar"></i> Preços
      </button>
      <button
        class="ia-toggle-btn"
        :class="abaAtiva === 'templates' ? 'active' : ''"
        @click="abaAtiva = 'templates'; buscarTemplates()"
      >
        <i class="bi bi-robot"></i> Templates de IA
      </button>
    </div>

    <!-- Conteúdo -->
    <div class="ia-content">
      <!-- ============================================================ -->
      <!-- ABA CONSUMO -->
      <!-- ============================================================ -->
      <template v-if="abaAtiva === 'consumo'">
        <!-- Filtros inline -->
        <div class="row g-3 align-items-end mb-3">
          <div class="col-md-3" v-if="authStore.isAdminInterno">
            <label class="form-label" for="filtroIdEmpresa">Empresa</label>
            <select
              id="filtroIdEmpresa"
              class="form-select"
              v-model.number="filtros.idEmpresa"
            >
              <option :value="null">Todas</option>
              <option
                v-for="emp in uiStore.listaEmpresasParaSelecao"
                :key="emp.idEmpresa"
                :value="emp.idEmpresa"
              >
                {{ emp.nomeEmpresa }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="filtroAplicacao">Aplicação</label>
            <select
              id="filtroAplicacao"
              class="form-select"
              v-model="filtros.aplicacao"
            >
              <option value="">Todas</option>
              <option
                v-for="app in listaAplicacoes"
                :key="app.id"
                :value="app.id"
              >
                {{ app.textoLista }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="filtroIdUsuario">Usuário</label>
            <select
              id="filtroIdUsuario"
              class="form-select"
              v-model.number="filtros.idUsuario"
            >
              <option :value="null">Todos</option>
              <option
                v-for="user in listaUsuarios"
                :key="user.idUsuario"
                :value="user.idUsuario"
              >
                {{ user.nome }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="filtroDataInicio">Data Início</label>
            <input
              id="filtroDataInicio"
              type="date"
              class="form-control"
              v-model="filtros.dataInicio"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label" for="filtroDataFim">Data Fim</label>
            <input
              id="filtroDataFim"
              type="date"
              class="form-control"
              v-model="filtros.dataFim"
            />
          </div>
          <div class="col-md-3">
            <label class="form-label" for="filtroIdSessao">Sessão (ID)</label>
            <input
              id="filtroIdSessao"
              type="text"
              class="form-control"
              v-model="filtros.idSessao"
              placeholder="ID da sessão..."
            />
          </div>
          <div class="col-12 text-end">
            <button class="btn btn-outline-danger me-2" @click="gerarRelatorioPDF" :disabled="loadingRelatorio || logs.length === 0">
              <i v-if="loadingRelatorio" class="spinner-border spinner-border-sm me-1"></i>
              <i v-else class="bi bi-filetype-pdf me-1"></i>
              Gerar Relatório PDF
            </button>
            <button class="btn btn-secondary me-2" @click="limparFiltros">Limpar</button>
            <button class="btn btn-primary" @click="aplicarFiltros">Aplicar Filtros</button>
          </div>
        </div>

        <!-- Resumo do período -->
        <div class="row g-3 mb-3">
          <div class="col">
            <div class="card border-0 shadow-sm bg-body-tertiary h-100">
              <div class="card-body text-center py-3">
                <div class="text-muted small">Total Tokens Input</div>
                <div class="fs-5 fw-bold">{{ totalTokensInput.toLocaleString('pt-BR') }}</div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card border-0 shadow-sm bg-body-tertiary h-100">
              <div class="card-body text-center py-3">
                <div class="text-muted small">Total Tokens Output</div>
                <div class="fs-5 fw-bold">{{ totalTokensOutput.toLocaleString('pt-BR') }}</div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card border-0 shadow-sm bg-body-tertiary h-100">
              <div class="card-body text-center py-3">
                <div class="text-muted small">Custo Total Estimado</div>
                <div class="fs-5 fw-bold">{{ custoTotalEstimado.toLocaleString('pt-BR', { style: 'currency', currency: 'USD', minimumFractionDigits: 8, maximumFractionDigits: 8 }) }}</div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card border-0 shadow-sm bg-body-tertiary h-100">
              <div class="card-body text-center py-3">
                <div class="text-muted small">Total de Sessões</div>
                <div class="fs-5 fw-bold">{{ totalSessoes.toLocaleString('pt-BR') }}</div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card border-0 shadow-sm bg-body-tertiary h-100">
              <div class="card-body text-center py-3">
                <div class="text-muted small">Custo Médio por Sessão</div>
                <div class="fs-5 fw-bold">{{ custoMedioSessao !== null ? custoMedioSessao.toLocaleString('pt-BR', { style: 'currency', currency: 'USD', minimumFractionDigits: 8, maximumFractionDigits: 8 }) : 'N/A' }}</div>
              </div>
            </div>
          </div>
        </div>

        <AdminTable
          :columns="colunasConsumo"
          :data="logs"
          :loading="loading"
          :sort-field="sortField"
          :sort-order="sortOrder"
          modulo-layout="IAConfiguracoesConsumo"
          :colunas-padrao="colunasConsumo"
          @sort-change="aoOrdenar"
        >
          <template #nomeEmpresa="{ row }">
            <span>{{ obterNomeEmpresa(row.idEmpresa) }}</span>
          </template>
          <template #nomeUsuario="{ row }">
            <span>{{ row.nomeUsuario || '-' }}</span>
          </template>
          <template #idSessao="{ row }">
            <span class="small font-monospace" :title="row.idSessao">
              {{ row.idSessao || '-' }}
            </span>
          </template>
          <template #tsCriacao="{ row }">
            <span class="small">{{ formatarDataHoraBR(row.tsCriacao) }}</span>
          </template>
          <template #tokensInput="{ row }">
            <span class="text-end d-block">{{ (row.tokensInput || 0).toLocaleString('pt-BR') }}</span>
          </template>
          <template #tokensOutput="{ row }">
            <span class="text-end d-block">{{ (row.tokensOutput || 0).toLocaleString('pt-BR') }}</span>
          </template>
          <template #custoEstimado="{ row }">
            <span>{{ (row.custoEstimado || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'USD', minimumFractionDigits: 8, maximumFractionDigits: 8 }) }}</span>
          </template>
          <template #acoes="{ row }">
            <button
              type="button"
              class="btn btn-sm btn-outline-info"
              @click="verDetalheLog(row)"
              title="Ver detalhes"
            >
              <i class="bi bi-eye"></i>
            </button>
          </template>
        </AdminTable>

        <!-- Paginação manual consumo -->
        <div class="d-flex justify-content-between align-items-center mt-3 ia-pagination-footer">
          <div class="d-flex align-items-center gap-2">
            <span class="text-muted small">Itens por página:</span>
            <select
              id="consumoPageSize"
              class="form-select form-select-sm"
              style="width: auto;"
              v-model.number="paginacao.PageSize"
              @change="mudarTamanhoPaginaConsumo"
            >
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
          </div>
          <div class="d-flex align-items-center gap-2">
            <small class="text-muted">
              Página {{ paginacao.CurrentPage }} de {{ paginacao.TotalPages || 1 }}
              ({{ paginacao.TotalCount }} registros)
            </small>
            <button
              class="btn btn-sm btn-outline-secondary"
              :disabled="!paginacao.HasPrevious"
              @click="mudarPaginaConsumo(paginacao.CurrentPage - 1)"
            >
              <i class="bi bi-chevron-left"></i>
            </button>
            <button
              class="btn btn-sm btn-outline-secondary"
              :disabled="!paginacao.HasNext"
              @click="mudarPaginaConsumo(paginacao.CurrentPage + 1)"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>

      </template>

      <!-- ============================================================ -->
      <!-- ABA PREÇOS -->
      <!-- ============================================================ -->
      <template v-if="abaAtiva === 'precos'">
        <div class="d-flex justify-content-end mb-3">
          <button class="btn btn-primary" @click="abrirModalPreco(null)">
            <i class="bi bi-plus-lg me-2"></i> Novo Preço
          </button>
        </div>

        <AdminTable
          :columns="colunasPrecos"
          :data="precos"
          :loading="loadingPrecos"
          :sort-field="precoSortField"
          :sort-order="precoSortOrder"
          @sort-change="aoOrdenarPrecos"
        >
          <template #lstProvider="{ row }">
            {{ obterNomeProvedor(row.lstProvider) }}
          </template>
          <template #precoInputPor1KTokens="{ row }">
            {{ (row.precoInputPor1KTokens || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'USD' }) }}
          </template>
          <template #precoOutputPor1KTokens="{ row }">
            {{ (row.precoOutputPor1KTokens || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'USD' }) }}
          </template>
          <template #dataInicioVigencia="{ row }">
            {{ formatarDataBR(row.dataInicioVigencia) }}
          </template>
          <template #dataFimVigencia="{ row }">
            {{ row.dataFimVigencia ? formatarDataBR(row.dataFimVigencia) : '-' }}
          </template>
          <template #ativo="{ row }">
            <span :class="row.ativo ? 'badge bg-success' : 'badge bg-secondary'">
              {{ row.ativo ? 'Ativo' : 'Inativo' }}
            </span>
          </template>
          <template #acoes="{ row }">
            <button
              type="button"
              class="btn btn-sm btn-outline-primary me-1"
              @click="abrirModalPreco(row)"
              title="Editar"
            >
              <i class="bi bi-pencil"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              @click="confirmarExclusaoPreco(row)"
              title="Excluir"
            >
              <i class="bi bi-trash"></i>
            </button>
          </template>
        </AdminTable>

        <!-- Paginação manual preços -->
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div class="d-flex align-items-center gap-2">
            <span class="text-muted small">Itens por página:</span>
            <select
              id="precosPageSize"
              class="form-select form-select-sm"
              style="width: auto;"
              v-model.number="precoPaginacao.pageSize"
              @change="mudarTamanhoPaginaPrecos"
            >
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
          </div>
          <div class="d-flex align-items-center gap-2">
            <small class="text-muted">
              Página {{ precoPaginacao.currentPage }} de {{ precoPaginacao.totalPages || 1 }}
              ({{ precoPaginacao.totalCount }} registros)
            </small>
            <button
              class="btn btn-sm btn-outline-secondary"
              :disabled="!precoPaginacao.hasPrevious"
              @click="mudarPaginaPrecos(precoPaginacao.currentPage - 1)"
            >
              <i class="bi bi-chevron-left"></i>
            </button>
            <button
              class="btn btn-sm btn-outline-secondary"
              :disabled="!precoPaginacao.hasNext"
              @click="mudarPaginaPrecos(precoPaginacao.currentPage + 1)"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
      </template>

      <!-- ============================================================ -->
      <!-- ABA TEMPLATES -->
      <!-- ============================================================ -->
      <template v-if="abaAtiva === 'templates'">
        <div class="d-flex justify-content-end mb-3">
          <button class="btn btn-primary" @click="abrirModalTemplateNovo">
            <i class="bi bi-plus-lg me-2"></i> Novo Template
          </button>
        </div>

        <div v-if="loadingTemplates" class="text-center text-muted small py-4">
          <span class="spinner-border spinner-border-sm me-2"></span> A carregar templates...
        </div>

        <div v-else class="table-responsive">
          <table class="table table-sm table-hover align-middle">
            <thead class="table-light">
              <tr>
                <th style="width: 30px;"></th>
                <th>Provider</th>
                <th>API Key</th>
                <th>Modelo</th>
                <th>Aplicações</th>
                <th class="text-center" style="width: 100px;">Status</th>
                <th class="text-end" style="width: 120px;">Ações</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="tmpl in templates" :key="tmpl.idClienteIntegracaoAiTemplate">
                <tr>
                  <td class="text-center">
                    <button
                      v-if="tmpl.aplicacoes && tmpl.aplicacoes.length > 0"
                      type="button"
                      class="btn btn-sm p-0 border-0 bg-transparent"
                      @click="toggleExpandTemplate(tmpl.idClienteIntegracaoAiTemplate)"
                    >
                      <i :class="['bi', expandedTemplateRows[tmpl.idClienteIntegracaoAiTemplate] ? 'bi-chevron-down' : 'bi-chevron-right', 'text-secondary']"></i>
                    </button>
                  </td>
                  <td>
                    <span class="fw-medium">{{ obterNomeProvedor(tmpl.lstProvider) }}</span>
                  </td>
                  <td>
                    <code class="small">{{ tmpl.apiKeyMasked || '-' }}</code>
                  </td>
                  <td>
                    <span class="text-truncate d-inline-block" style="max-width: 200px;" :title="tmpl.model">
                      {{ tmpl.model || '-' }}
                    </span>
                  </td>
                  <td>
                    <span v-if="tmpl.aplicacoes && tmpl.aplicacoes.length > 0" class="text-muted small">
                      {{ tmpl.aplicacoes.length }} aplicação(ões)
                    </span>
                    <span v-else class="text-muted small">-</span>
                  </td>
                  <td class="text-center">
                    <span :class="['badge', tmpl.lstStatus === 'ST1' ? 'badge-ghost-success' : 'badge-ghost-secondary']">
                      {{ tmpl.lstStatus }}
                    </span>
                  </td>
                  <td class="text-end">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary me-1"
                      @click="editarTemplate(tmpl)"
                      title="Editar"
                    >
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      @click="confirmarExclusaoTemplate(tmpl)"
                      title="Excluir"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
                <!-- Sub-linha expansível com as aplicações -->
                <tr v-if="expandedTemplateRows[tmpl.idClienteIntegracaoAiTemplate] && tmpl.aplicacoes && tmpl.aplicacoes.length > 0">
                  <td colspan="7" class="p-0 bg-body-tertiary">
                    <div class="px-4 py-2 border-start border-2 border-primary ms-3 my-1">
                      <div v-for="app in tmpl.aplicacoes" :key="app.idClienteIntegracaoAiTemplateAplicacoes || app.idClienteIntegracaoAiAplicacoes || app.lstAplicacoesAi" class="d-flex align-items-center gap-2 mb-1">
                        <span class="badge badge-ghost-info">{{ getTextoLista(listaAplicacoes, app.lstAplicacoesAi) }}</span>
                        <span class="text-muted small" v-if="app.observacoes">
                          <i class="bi bi-chat-dots me-1"></i>{{ app.observacoes }}
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <tr v-if="templates.length === 0">
                <td colspan="7" class="text-center text-muted py-3">
                  Nenhum template de IA cadastrado.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>

    <!-- ============================================================ -->
    <!-- MODAIS -->
    <!-- ============================================================ -->

    <!-- Modal de Detalhe do Log -->
    <ModalFormularioV2
      v-model="modalDetalheVisivel"
      :titulo="'Detalhe do Consumo #' + (detalheLog?.idIaUsageLog || '')"
      tamanho="lg"
      :loading="false"
    >
      <div class="row g-3" v-if="detalheLog">
        <div class="col-md-6">
          <label class="form-label small fw-bold">Data/Hora</label>
          <p class="mb-0">{{ formatarDataHoraBR(detalheLog.tsCriacao) }}</p>
        </div>
        <div class="col-md-6">
          <label class="form-label small fw-bold">Aplicação</label>
          <p class="mb-0">{{ detalheLog.origemTexto || '-' }}</p>
        </div>
        <div class="col-md-4">
          <label class="form-label small fw-bold">Provedor</label>
          <p class="mb-0">{{ obterNomeProvedor(detalheLog.lstProvider) }}</p>
        </div>
        <div class="col-md-4">
          <label class="form-label small fw-bold">Modelo</label>
          <p class="mb-0"><code>{{ detalheLog.model || '-' }}</code></p>
        </div>
        <div class="col-md-4">
          <label class="form-label small fw-bold">Custo Estimado</label>
          <p class="mb-0">{{ (detalheLog.custoEstimado || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'USD', minimumFractionDigits: 8, maximumFractionDigits: 8 }) }}</p>
        </div>
        <div class="col-md-6">
          <label class="form-label small fw-bold">Tokens Input</label>
          <p class="mb-0">{{ (detalheLog.tokensInput || 0).toLocaleString('pt-BR') }}</p>
        </div>
        <div class="col-md-6">
          <label class="form-label small fw-bold">Tokens Output</label>
          <p class="mb-0">{{ (detalheLog.tokensOutput || 0).toLocaleString('pt-BR') }}</p>
        </div>
        <div class="col-12" v-if="detalheLog.promptTruncado">
          <label class="form-label small fw-bold">Prompt (truncado)</label>
          <textarea
            class="form-control font-monospace small"
            rows="4"
            readonly
            :value="detalheLog.promptTruncado"
            style="resize: vertical;"
          ></textarea>
        </div>
        <div class="col-12" v-if="detalheLog.responseTruncado">
          <label class="form-label small fw-bold">Response (truncado)</label>
          <textarea
            class="form-control font-monospace small"
            rows="4"
            readonly
            :value="detalheLog.responseTruncado"
            style="resize: vertical;"
          ></textarea>
        </div>
      </div>
      <template #footer>
        <div class="d-flex gap-2 w-100 justify-content-end">
          <button type="button" class="btn btn-outline-secondary" @click="modalDetalheVisivel = false">
            Fechar
          </button>
        </div>
      </template>
    </ModalFormularioV2>

    <!-- Modal de Preço -->
    <IAProviderPrecoModal
      v-model="modalPrecoVisivel"
      :item-para-editar="precoParaEditar"
      @salvo="onPrecoSalvo"
      @show-notification="emit('show-notification', $event)"
    />

    <!-- Modal de Template -->
    <ModalFormulario
      v-model="modalTemplateVisivel"
      :titulo="modalTemplateItem.idClienteIntegracaoAiTemplate ? 'Editar Template de IA' : 'Novo Template de IA'"
      :loading="modalTemplateSalvando"
      @confirmar="salvarTemplate"
    >
      <div class="row g-3">
        <!-- Bloco: Identificação -->
        <div class="col-12">
          <h6 class="border-bottom pb-2 mb-3 text-primary">
            <i class="bi bi-tag me-1"></i> Identificação
          </h6>
        </div>
        <div class="col-md-6">
          <CampoSelect
            id="templateLstProvider"
            label="Provider"
            v-model="modalTemplateItem.lstProvider"
            :options="listaProvedores"
            option-value="id"
            option-label="textoLista"
            required
          />
        </div>
        <div class="col-md-3">
          <CampoSelect
            id="templateLstStatus"
            label="Status"
            v-model="modalTemplateItem.lstStatus"
            :options="statusOptions"
            option-value="id"
            option-label="label"
            required
          />
        </div>
        <div class="col-md-3">
          <CampoInput
            id="templateObservacoes"
            label="Observações"
            type="textarea"
            v-model="modalTemplateItem.observacoes"
          />
        </div>

        <!-- Bloco: API Key -->
        <div class="col-12 mt-2">
          <h6 class="border-bottom pb-2 mb-3 text-primary">
            <i class="bi bi-key me-1"></i> Credenciais
          </h6>
        </div>
        <div class="col-12">
          <CampoInput
            id="templateApiKey"
            label="API Key (opcional)"
            type="password"
            v-model="modalTemplateItem.apiKey"
            :placeholder="modalTemplateItem.idClienteIntegracaoAiTemplate ? 'Deixe vazio para manter a atual' : 'sk-...'"
          />
          <small class="text-muted">
            <i class="bi bi-info-circle me-1"></i>
            A chave será criptografada. Se vazia, a empresa deverá fornecer a própria chave ao aplicar o seed.
          </small>
        </div>

        <!-- Bloco: Configuração do Modelo -->
        <div class="col-12 mt-2">
          <h6 class="border-bottom pb-2 mb-3 text-primary">
            <i class="bi bi-cpu me-1"></i> Configuração do Modelo
          </h6>
        </div>
        <div class="col-md-8">
          <CampoInput
            id="templateUrlEndpoint"
            label="URL Endpoint"
            v-model="modalTemplateItem.urlEndpoint"
            placeholder="https://api.openai.com/v1"
          />
        </div>
        <div class="col-md-4">
          <CampoInput
            id="templateModel"
            label="Modelo"
            type="textarea"
            v-model="modalTemplateItem.model"
            placeholder="Ex: google/gemini-2.5-flash-lite"
          />
          <small class="text-muted">
            <i class="bi bi-info-circle me-1"></i>
            Insira um modelo por linha para fallback automático em caso de indisponibilidade do principal.
          </small>
        </div>

        <div class="col-md-3">
          <CampoInput
            id="templateTemperature"
            label="Temperature"
            type="number"
            step="0.1"
            min="0"
            max="2"
            v-model.number="modalTemplateItem.temperature"
          />
        </div>
        <div class="col-md-3">
          <CampoInput
            id="templateMaxTokens"
            label="Max Tokens"
            type="number"
            min="1"
            v-model.number="modalTemplateItem.maxTokens"
          />
        </div>
        <div class="col-md-3">
          <CampoInput
            id="templateTimeoutSeconds"
            label="Timeout (segundos)"
            type="number"
            min="1"
            v-model.number="modalTemplateItem.timeoutSeconds"
          />
        </div>
        <div class="col-md-3">
          <CampoInput
            id="templateResponseFormat"
            label="Response Format"
            v-model="modalTemplateItem.responseFormat"
            placeholder="text, json_object"
          />
        </div>

        <div class="col-12">
          <div class="form-check form-switch mt-2">
            <input class="form-check-input cursor-pointer" type="checkbox" id="templateEnableStreaming" v-model="modalTemplateItem.enableStreaming">
            <label class="form-check-label cursor-pointer" for="templateEnableStreaming">
              <span class="fw-medium">Habilitar Streaming</span>
            </label>
          </div>
        </div>

        <!-- Aplicações Vinculadas -->
        <div class="col-12 mt-3">
          <h6 class="border-bottom pb-2 mb-3">
            <i class="bi bi-app me-1"></i> Aplicações Vinculadas
          </h6>
          <div class="table-responsive border rounded p-2 bg-body-tertiary">
            <table class="table table-sm align-middle mb-0">
              <thead>
                <tr>
                  <th>Aplicação</th>
                  <th>Observações</th>
                  <th style="width: 50px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(app, index) in modalTemplateAplicacoes" :key="index">
                  <td>
                    <span class="badge badge-ghost-info">
                      {{ getTextoLista(listaAplicacoes, app.lstAplicacoesAi) }}
                    </span>
                  </td>
                  <td class="text-muted small">{{ app.observacoes || '-' }}</td>
                  <td class="text-end">
                    <button type="button" class="btn btn-sm text-danger" @click="removerAplicacaoTemplate(index)">
                      <i class="bi bi-x-lg"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="modalTemplateAplicacoes.length === 0">
                  <td colspan="3" class="text-center text-muted py-2">
                    Nenhuma aplicação vinculada.
                  </td>
                </tr>
              </tbody>
            </table>
            <button type="button" class="btn btn-sm btn-link text-primary p-0 mt-2" @click="abrirModalAplicacaoTemplate">
              <i class="bi bi-plus-lg me-1"></i> Adicionar Aplicação
            </button>
          </div>
        </div>

        <!-- Testar Conexão -->
        <div class="col-12" v-if="modalTemplateItem.apiKey">
          <button
            type="button"
            class="btn btn-outline-info btn-sm"
            @click="testarConexaoTemplate"
            :disabled="modalTemplateTestando"
          >
            <span v-if="modalTemplateTestando" class="spinner-border spinner-border-sm me-1"></span>
            <i v-else class="bi bi-plug me-1"></i>
            Testar Conexão
          </button>
          <small v-if="modalTemplateResultadoTeste" class="ms-2" :class="modalTemplateResultadoTeste.sucesso ? 'text-success' : 'text-danger'">
            {{ modalTemplateResultadoTeste.mensagem }}
          </small>
        </div>
      </div>
    </ModalFormulario>

    <!-- Modal para Adicionar Aplicação ao Template -->
    <ModalFormulario
      v-model="modalTemplateAplicacaoVisivel"
      titulo="Adicionar Aplicação"
      :loading="false"
      @confirmar="confirmarAdicionarAplicacaoTemplate"
    >
      <div class="row g-3">
        <div class="col-12">
          <CampoBuscaLista
            id="lstAplicacoesAiTemplate"
            label="Aplicação"
            v-model="modalTemplateAplicacaoItem.lstAplicacoesAi"
            tabela="ClienteIntegracaoAiAplicacoes"
            required
          />
        </div>
        <div class="col-12">
          <CampoInput
            id="obsAplicacaoTemplateModal"
            label="Observações"
            v-model="modalTemplateAplicacaoItem.observacoes"
          />
        </div>
      </div>
    </ModalFormulario>

    <!-- Modal de Confirmação de Exclusão de Template -->
    <ConfirmationModal
      ref="confirmacaoTemplateRef"
      title="Excluir Template de IA"
      message="Deseja realmente excluir este template de configuração de IA?"
      confirm-button-text="Sim, Excluir"
      cancel-button-text="Cancelar"
      @confirmed="aoConfirmarExclusaoTemplate"
    />

    <!-- Componente oculto de relatório PDF -->
    <IAConfiguracoesRelatorio
      ref="relatorioRef"
      :dados="logs"
      :filtros="filtrosRelatorio"
    />
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import api from '@/services/api'
import { useAuthStore } from '@/stores/auth'
import { useUiStore } from '@/stores/ui'
import { useMetadataListasStore } from '@/stores/metadataListas'
import { usePaginacao } from '@/composables/usePaginacao'
import { formatarDataBR, formatarDataHoraBR } from '@/utils/useDataBR'
import { imprimirPagedJs } from '@/services/relatorioPrintService'
import AdminTable from '@/components/base/grid/AdminTable.vue'
import ModalFormularioV2 from '@/components/base/modal/ModalFormularioV2.vue'
import ModalFormulario from '@/components/base/modal/ModalFormulario.vue'
import ConfirmationModal from '@/components/base/modal/ConfirmationModal.vue'
import CampoInput from '@/components/base/campos/CampoInput.vue'
import CampoSelect from '@/components/base/campos/CampoSelect.vue'
import CampoBuscaLista from '@/components/base/campos/CampoBuscaLista.vue'
import IAProviderPrecoModal from './IAProviderPrecoModal.vue'
import IAConfiguracoesRelatorio from './IAConfiguracoesRelatorio.vue'

const emit = defineEmits(['show-notification'])

const authStore = useAuthStore()
const uiStore = useUiStore()
const metadataListasStore = useMetadataListasStore()

// ============================================================
// Estado geral
// ============================================================
const abaAtiva = ref('consumo')
const loading = ref(false)
const loadingPrecos = ref(false)
const loadingTemplates = ref(false)
const loadingRelatorio = ref(false)
const logs = ref([])
const precos = ref([])
const templates = ref([])
const sortField = ref('')
const sortOrder = ref('')
const precoSortField = ref('')
const precoSortOrder = ref('')

// ============================================================
// Paginação
// ============================================================
const { paginacao, atualizarPaginacao } = usePaginacao()
const precoPaginacao = reactive({
  currentPage: 1,
  pageSize: 25,
  totalCount: 0,
  totalPages: 0,
  hasNext: false,
  hasPrevious: false
})

// ============================================================
// Filtros
// ============================================================
const filtros = reactive({
  idEmpresa: null,
  aplicacao: '',
  idUsuario: null,
  dataInicio: '',
  dataFim: '',
  idSessao: ''
})

const filtrosRelatorio = computed(() => ({
  empresa: filtros.idEmpresa ? uiStore.listaEmpresasParaSelecao.find(e => e.idEmpresa === filtros.idEmpresa)?.nomeEmpresa || `ID ${filtros.idEmpresa}` : 'Todas',
  aplicacao: filtros.aplicacao || 'Todas',
  idSessao: filtros.idSessao || '',
  dataInicio: filtros.dataInicio || '',
  dataFim: filtros.dataFim || ''
}))

// ============================================================
// Listas do sistema
// ============================================================
const listaAplicacoes = ref([])
const listaProvedores = ref([])
const listaUsuarios = ref([])

const carregarListas = async () => {
  // CONFIG_IA_APLICACOES_SIS e CONFIG_PROVIDERS_IA são listas estruturais
  // Como não há mapeamento no DicionarioMetadados para IAUsageLog,
  // usamos getListaLookup direto pela store (não api.get direto)
  listaAplicacoes.value = await metadataListasStore.getListaLookup('CONFIG_IA_APLICACOES_SIS', 'Sistema') || []
  listaProvedores.value = await metadataListasStore.getListaLookup('CONFIG_PROVIDERS_IA', 'Sistema') || []
  // Carrega lista de usuários para o filtro
  try {
    const response = await api.get('/Usuarios', { params: { pageSize: 1000 } })
    listaUsuarios.value = response.data || []
  } catch (e) {
    listaUsuarios.value = []
  }
}

const obterNomeEmpresa = (id) => {
  if (!id) return '-'
  const empresa = uiStore.listaEmpresasParaSelecao.find(e => String(e.idEmpresa) === String(id))
  return empresa?.nomeEmpresa || `ID ${id}`
}

const obterNomeProvedor = (id) => {
  if (!id) return '-'
  const item = listaProvedores.value.find(p => String(p.id) === String(id))
  return item?.textoLista || id
}

// ============================================================
// Colunas da tabela Consumo
// ============================================================
const colunasConsumo = computed(() => [
  { field: 'tsCriacao', label: 'Data/Hora', width: 130, sortable: true, slotName: 'tsCriacao' },
  { field: 'idEmpresa', label: 'Empresa', width: 270, sortable: true, slotName: 'nomeEmpresa' },
  { field: 'origemTexto', label: 'Aplicação', width: 270, sortable: true },
  { field: 'lstProvider', label: 'Provedor', width: 200, sortable: true },
  { field: 'model', label: 'Modelo', width: 270, sortable: true },
  { field: 'nomeUsuario', label: 'Usuário', width: 150, sortable: true, slotName: 'nomeUsuario' },
  { field: 'idSessao', label: 'Sessão', width: 120, sortable: true, slotName: 'idSessao' },
  { field: 'tokensInput', label: 'Tokens In', width: 80, sortable: true, align: 'right', slotName: 'tokensInput' },
  { field: 'tokensOutput', label: 'Tokens Out', width: 80, sortable: true, align: 'right', slotName: 'tokensOutput' },
  { field: 'custoEstimado', label: 'Custo Estimado', width: 130, sortable: true, align: 'right', slotName: 'custoEstimado' },
  { field: 'acoes', label: '', width: 60, align: 'right', slotName: 'acoes', resizable: false, sortable: false }
])

// ============================================================
// Colunas da tabela Preços
// ============================================================
const colunasPrecos = computed(() => [
  { field: 'lstProvider', label: 'Provedor', width: 120, sortable: true, slotName: 'lstProvider' },
  { field: 'model', label: 'Modelo', width: 200, sortable: true },
  { field: 'precoInputPor1KTokens', label: 'Preço Input (1K)', width: 140, sortable: true, align: 'right', slotName: 'precoInputPor1KTokens' },
  { field: 'precoOutputPor1KTokens', label: 'Preço Output (1K)', width: 140, sortable: true, align: 'right', slotName: 'precoOutputPor1KTokens' },
  { field: 'dataInicioVigencia', label: 'Vigência Início', width: 130, sortable: true, slotName: 'dataInicioVigencia' },
  { field: 'dataFimVigencia', label: 'Vigência Fim', width: 130, sortable: true, slotName: 'dataFimVigencia' },
  { field: 'ativo', label: 'Status', width: 90, sortable: true, slotName: 'ativo' },
  { field: 'acoes', label: '', width: 100, align: 'right', slotName: 'acoes', resizable: false, sortable: false }
])

// ============================================================
// Expansão de linha (aplicações dos templates)
// ============================================================
const expandedTemplateRows = reactive({})

const toggleExpandTemplate = (id) => {
  expandedTemplateRows[id] = !expandedTemplateRows[id]
}

// ============================================================
// Totalizadores
// ============================================================
const totalTokensInput = computed(() => logs.value.reduce((acc, log) => acc + (log.tokensInput || 0), 0))
const totalTokensOutput = computed(() => logs.value.reduce((acc, log) => acc + (log.tokensOutput || 0), 0))
const custoTotalEstimado = computed(() => logs.value.reduce((acc, log) => acc + (log.custoEstimado || 0), 0))

// Total de sessões únicas
const totalSessoes = computed(() => {
  const sessoes = new Set()
  for (const log of logs.value) {
    if (log.idSessao) sessoes.add(log.idSessao)
  }
  return sessoes.size
})

// Custo médio por sessão: agrupa logs por idSessao e calcula média do custo
const custoMedioSessao = computed(() => {
  const sessoes = {}
  for (const log of logs.value) {
    if (!log.idSessao) continue
    if (!sessoes[log.idSessao]) sessoes[log.idSessao] = { soma: 0, count: 0 }
    sessoes[log.idSessao].soma += log.custoEstimado || 0
    sessoes[log.idSessao].count++
  }
  const chaves = Object.keys(sessoes)
  if (chaves.length === 0) return null
  const total = chaves.reduce((acc, k) => acc + sessoes[k].soma, 0)
  return total / chaves.length
})

// ============================================================
// Modal de detalhe do log
// ============================================================
const modalDetalheVisivel = ref(false)
const detalheLog = ref(null)

const verDetalheLog = async (log) => {
  try {
    const response = await api.get(`/IAUsageLogs/${log.idIaUsageLog}`)
    detalheLog.value = response.data
    modalDetalheVisivel.value = true
  } catch (error) {
    emit('show-notification', { message: 'Erro ao carregar detalhe do log.', type: 'error' })
  }
}

// ============================================================
// Modal de Preço
// ============================================================
const modalPrecoVisivel = ref(false)
const precoParaEditar = ref(null)

const abrirModalPreco = (preco) => {
  precoParaEditar.value = preco ? { ...preco } : null
  modalPrecoVisivel.value = true
}

const onPrecoSalvo = () => {
  modalPrecoVisivel.value = false
  precoParaEditar.value = null
  buscarPrecos()
}

// ============================================================
// Modal de Template
// ============================================================
const modalTemplateVisivel = ref(false)
const modalTemplateSalvando = ref(false)
const modalTemplateAplicacoes = ref([])
const modalTemplateTestando = ref(false)
const modalTemplateResultadoTeste = ref(null)

const modeloVazioTemplate = {
  idClienteIntegracaoAiTemplate: 0,
  lstProvider: '',
  apiKey: '',
  urlEndpoint: '',
  model: '',
  temperature: null,
  maxTokens: null,
  timeoutSeconds: null,
  enableStreaming: false,
  responseFormat: '',
  lstStatus: 'ST1',
  observacoes: ''
}

const modalTemplateItem = reactive({ ...modeloVazioTemplate })

const statusOptions = [
  { id: 'ST1', label: 'Ativo' },
  { id: 'ST2', label: 'Inativo' }
]

// Modal de adição de aplicação ao template
const modalTemplateAplicacaoVisivel = ref(false)
const modalTemplateAplicacaoItem = reactive({
  lstAplicacoesAi: '',
  observacoes: ''
})

const getTextoLista = (lista, id) => {
  if (!lista) return id || '-'
  const obj = lista.find(i =>
    String(i.id) === String(id) ||
    String(i.idListaSistemaItem) === String(id) ||
    String(i.idListaClienteItem) === String(id) ||
    i.textoLista === id
  )
  return obj ? obj.textoLista : id
}

const abrirModalTemplateNovo = () => {
  Object.assign(modalTemplateItem, { ...modeloVazioTemplate })
  modalTemplateAplicacoes.value = []
  modalTemplateResultadoTeste.value = null
  modalTemplateVisivel.value = true
}

const editarTemplate = (tmpl) => {
  Object.assign(modalTemplateItem, {
    idClienteIntegracaoAiTemplate: tmpl.idClienteIntegracaoAiTemplate,
    lstProvider: tmpl.lstProvider,
    apiKey: '',
    urlEndpoint: tmpl.urlEndpoint || '',
    model: tmpl.model || '',
    temperature: tmpl.temperature ?? null,
    maxTokens: tmpl.maxTokens ?? null,
    timeoutSeconds: tmpl.timeoutSeconds ?? null,
    enableStreaming: tmpl.enableStreaming ?? false,
    responseFormat: tmpl.responseFormat || '',
    lstStatus: tmpl.lstStatus,
    observacoes: tmpl.observacoes || ''
  })
  modalTemplateAplicacoes.value = (tmpl.aplicacoes || []).map(a => ({
    lstAplicacoesAi: a.lstAplicacoesAi || '',
    observacoes: a.observacoes || ''
  }))
  modalTemplateResultadoTeste.value = null
  modalTemplateVisivel.value = true
}

const abrirModalAplicacaoTemplate = () => {
  modalTemplateAplicacaoItem.lstAplicacoesAi = ''
  modalTemplateAplicacaoItem.observacoes = ''
  modalTemplateAplicacaoVisivel.value = true
}

const confirmarAdicionarAplicacaoTemplate = () => {
  if (!modalTemplateAplicacaoItem.lstAplicacoesAi) {
    emit('show-notification', { message: 'Selecione uma aplicação.', type: 'warning' })
    return
  }
  modalTemplateAplicacoes.value.push({
    lstAplicacoesAi: modalTemplateAplicacaoItem.lstAplicacoesAi,
    observacoes: modalTemplateAplicacaoItem.observacoes
  })
  modalTemplateAplicacaoVisivel.value = false
}

const removerAplicacaoTemplate = (index) => {
  modalTemplateAplicacoes.value.splice(index, 1)
}

const testarConexaoTemplate = async () => {
  if (!modalTemplateItem.apiKey || !modalTemplateItem.lstProvider) return

  modalTemplateTestando.value = true
  modalTemplateResultadoTeste.value = null
  try {
    const response = await api.post('/ClienteIntegracoesAiTemplates/testar-conexao', {
      lstProvider: modalTemplateItem.lstProvider,
      apiKey: modalTemplateItem.apiKey,
      urlEndpoint: modalTemplateItem.urlEndpoint || null,
      model: modalTemplateItem.model || null
    })
    modalTemplateResultadoTeste.value = {
      sucesso: true,
      mensagem: response.data.mensagem || 'Conexão estabelecida com sucesso!'
    }
  } catch (error) {
    modalTemplateResultadoTeste.value = {
      sucesso: false,
      mensagem: error.response?.data?.message || 'Falha ao testar conexão.'
    }
  } finally {
    modalTemplateTestando.value = false
  }
}

const salvarTemplate = async () => {
  if (!modalTemplateItem.lstProvider) {
    emit('show-notification', { message: 'O Provider é obrigatório.', type: 'warning' })
    return
  }

  modalTemplateSalvando.value = true
  try {
    const payload = {
      ...modalTemplateItem,
      aplicacoes: modalTemplateAplicacoes.value.filter(a => a.lstAplicacoesAi)
    }

    if (modalTemplateItem.idClienteIntegracaoAiTemplate) {
      await api.put(`/ClienteIntegracoesAiTemplates/${modalTemplateItem.idClienteIntegracaoAiTemplate}`, payload)
    } else {
      await api.post('/ClienteIntegracoesAiTemplates', payload)
    }

    modalTemplateVisivel.value = false
    buscarTemplates()
    emit('show-notification', { message: 'Template salvo com sucesso!', type: 'success' })
  } catch (error) {
    const data = error.response?.data
    let msg = 'Erro ao salvar o template.'

    if (typeof data === 'string') {
      msg = data
    } else if (data?.message) {
      msg = data.message
    } else if (data?.title) {
      msg = data.title
    } else if (data?.errors) {
      msg = Object.values(data.errors).flat().join('; ')
    }

    emit('show-notification', { message: msg, type: 'error' })
  } finally {
    modalTemplateSalvando.value = false
  }
}

// ============================================================
// Exclusão de Template
// ============================================================
const confirmacaoTemplateRef = ref(null)
const exclusaoTemplatePendenteId = ref(null)

const confirmarExclusaoTemplate = (tmpl) => {
  exclusaoTemplatePendenteId.value = tmpl.idClienteIntegracaoAiTemplate
  confirmacaoTemplateRef.value?.show()
}

const aoConfirmarExclusaoTemplate = async (confirmed) => {
  if (!confirmed || exclusaoTemplatePendenteId.value === null) return

  const id = exclusaoTemplatePendenteId.value
  exclusaoTemplatePendenteId.value = null

  try {
    await api.delete(`/ClienteIntegracoesAiTemplates/${id}`)
    buscarTemplates()
    emit('show-notification', { message: 'Template excluído com sucesso!', type: 'success' })
  } catch (error) {
    const data = error.response?.data
    let msg = 'Erro ao excluir o template.'

    if (typeof data === 'string') {
      msg = data
    } else if (data?.message) {
      msg = data.message
    } else if (data?.title) {
      msg = data.title
    } else if (data?.errors) {
      msg = Object.values(data.errors).flat().join('; ')
    }

    emit('show-notification', { message: msg, type: 'error' })
  }
}

// ============================================================
// Busca de dados
// ============================================================
const buscarDados = async (page) => {
  const pageNum = page || paginacao.value.CurrentPage
  loading.value = true
  try {
    const params = new URLSearchParams()
    params.append('page', pageNum)
    params.append('pageSize', paginacao.value.PageSize || 25)

    if (filtros.idEmpresa) params.append('idEmpresa', filtros.idEmpresa)
    if (filtros.aplicacao) params.append('lstOrigem', filtros.aplicacao)
    if (filtros.idUsuario) params.append('idUsuario', filtros.idUsuario)
    if (filtros.dataInicio) params.append('dataInicio', new Date(filtros.dataInicio).toISOString())
    if (filtros.dataFim) params.append('dataFim', new Date(filtros.dataFim + 'T23:59:59').toISOString())
    if (filtros.idSessao) params.append('idSessao', filtros.idSessao)

    const response = await api.get('/IAUsageLogs?' + params.toString())
    logs.value = response.data
    atualizarPaginacao(response.headers)
  } catch (error) {
    emit('show-notification', { message: 'Erro ao carregar logs de consumo.', type: 'error' })
  } finally {
    loading.value = false
  }
}

const buscarPrecos = async () => {
  loadingPrecos.value = true
  try {
    const response = await api.get('/IAProviderPrecos')
    precos.value = response.data
  } catch (error) {
    emit('show-notification', { message: 'Erro ao carregar preços.', type: 'error' })
  } finally {
    loadingPrecos.value = false
  }
}

const buscarTemplates = async () => {
  loadingTemplates.value = true
  try {
    const response = await api.get('/ClienteIntegracoesAiTemplates')
    templates.value = response.data
  } catch (error) {
    emit('show-notification', { message: 'Erro ao carregar templates.', type: 'error' })
  } finally {
    loadingTemplates.value = false
  }
}

// ============================================================
// Ações de filtro / paginação
// ============================================================
const aplicarFiltros = () => {
  if (abaAtiva.value === 'consumo') {
    buscarDados(1)
  }
}

const limparFiltros = () => {
  filtros.idEmpresa = null
  filtros.aplicacao = ''
  filtros.idUsuario = null
  filtros.dataInicio = ''
  filtros.dataFim = ''
  filtros.idSessao = ''
  buscarDados(1)
}

const mudarPaginaConsumo = (page) => {
  if (page >= 1 && page <= (paginacao.value.TotalPages || 1)) {
    buscarDados(page)
  }
}

const mudarPaginaPrecos = () => {
  buscarPrecos()
}

const mudarTamanhoPaginaConsumo = () => {
  buscarDados(1)
}

const mudarTamanhoPaginaPrecos = () => {
  buscarPrecos()
}

const aoOrdenar = ({ field, order }) => {
  sortField.value = field
  sortOrder.value = order
}

const aoOrdenarPrecos = ({ field, order }) => {
  precoSortField.value = field
  precoSortOrder.value = order
}

// ============================================================
// Exclusão de preço
// ============================================================
const confirmarExclusaoPreco = (preco) => {
  emit('show-notification', {
    message: `Deseja realmente excluir o preço do modelo "${preco.model}"?`,
    type: 'warning'
  })
  emit('confirm-action', {
    title: 'Confirmar Exclusão',
    message: `Tem a certeza que deseja excluir o preço do modelo "${preco.model}"?`,
    callback: async (confirmed) => {
      if (!confirmed) return
      try {
        await api.delete(`/IAProviderPrecos/${preco.idIaProviderPreco}`)
        emit('show-notification', { message: 'Preço excluído com sucesso.', type: 'success' })
        buscarPrecos()
      } catch (error) {
        const data = error.response?.data
        let msg = 'Erro ao excluir preço.'

        if (typeof data === 'string') {
          msg = data
        } else if (data?.message) {
          msg = data.message
        } else if (data?.title) {
          msg = data.title
        } else if (data?.errors) {
          msg = Object.values(data.errors).flat().join('; ')
        }

        emit('show-notification', { message: msg, type: 'error' })
      }
    }
  })
}

// ============================================================
// Relatório PDF
// ============================================================
const relatorioRef = ref(null)

const gerarRelatorioPDF = async () => {
  if (!logs.value || logs.value.length === 0) {
    emit('show-notification', { message: 'Nenhum dado para gerar relatório.', type: 'warning' })
    return
  }
  loadingRelatorio.value = true
  try {
    await imprimirPagedJs(relatorioRef.value.$el, {
      pageSize: 'A4',
      pageOrientation: 'landscape',
      arquivo: 'relatorio-consumo-ia'
    })
    emit('show-notification', { message: 'Relatório PDF gerado com sucesso!', type: 'success' })
  } catch (error) {
    emit('show-notification', { message: 'Erro ao gerar relatório PDF.', type: 'error' })
  } finally {
    loadingRelatorio.value = false
  }
}

// ============================================================
// Expose para o MainDashboard
// ============================================================
defineExpose({ buscarDados, buscarPrecos, buscarTemplates })

// ============================================================
// Init
// ============================================================
onMounted(async () => {
  if (uiStore.listaEmpresasParaSelecao.length === 0) {
    await uiStore.buscarEmpresasParaSelecao()
  }
  await carregarListas()
  buscarDados(1)
})
</script>

<style scoped>
.ia-configuracoes-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
}

.ia-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ia-header-title h4 {
  margin: 0;
  font-weight: 600;
}

.ia-header-title span {
  font-size: 0.875rem;
  color: var(--bs-secondary-color);
}

.ia-toggles {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.ia-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: 2px solid var(--bs-border-color);
  border-radius: 0.5rem;
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
  font-weight: 500;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.ia-toggle-btn:hover {
  border-color: var(--bs-primary);
  background: var(--bs-tertiary-bg);
}

.ia-toggle-btn.active {
  border-color: var(--bs-primary);
  background: var(--bs-primary);
  color: #fff;
}

.ia-toggle-btn i {
  font-size: 1.25rem;
}

.ia-content {
  min-height: 300px;
}

/* ============================================================ */
/* AdminTable header */
/* ============================================================ */
.ia-content :deep(.admin-table thead th) {
  background-color: #34495E !important;
  color: #FFFFFF !important;
  font-weight: 600;
  border-bottom: 2px solid #2c3e50;
}

/* ============================================================ */
/* AdminTable body rows */
/* ============================================================ */
.ia-content :deep(.admin-table tbody tr:hover td) {
  background-color: rgba(52, 152, 219, 0.05);
}

.ia-content :deep(.admin-table tbody tr:nth-child(even) td) {
  background-color: var(--bs-tertiary-bg);
}

/* ============================================================ */
/* Paginação footer */
/* ============================================================ */
.ia-pagination-footer {
  background-color: var(--bs-tertiary-bg);
  border-top: 1px solid var(--bs-border-color);
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  margin-top: 1rem;
}

/* ============================================================ */
/* Toggle buttons */
/* ============================================================ */
.ia-toggle-btn.active {
  background-color: #34495E;
  color: #fff;
  border-color: #34495E;
}

.ia-toggle-btn {
  padding: 0.5rem 1.25rem;
  border: 1px solid var(--bs-border-color);
  background: var(--bs-body-bg);
  color: var(--bs-body-color);
  border-radius: 0.25rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.ia-toggle-btn:hover:not(.active) {
  background-color: var(--bs-tertiary-bg);
}

/* ============================================================ */
/* Cards de resumo */
/* ============================================================ */
.ia-content :deep(.card.bg-body-tertiary) {
  border-left: 4px solid #34495E !important;
}
</style>
